import {PhoneHQAvatar, PhoneHQIconAvatar, PhoneHQButton, PhoneHQInput, PhoneHQLoader, PhoneHQActionDialog} from 'ch3-ui-lib';
import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import AddUserNumberModal from "./AddUserNumberModal";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {validateName} from "../../utilis/commonValidators";
import {useNavigate} from 'react-router-dom';
import DeleteGroupModal from "./DeleteGroup";
import {Colors, selectorItem} from "../../utilis/types/Types";
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {showToast} from "../../store/features/Notifications/notificationsSlice";
import {
    Group,
    useAddGroupMutation, useFetchAdminGroupByIdQuery,
    useFetchGroupByIdQuery,
    useUpdateGroupMutation
} from "../../store/features/groups/groupsService";
import {useGetUsersQuery, User, UserListItem} from "../../store/features/Users/userService";
import {Msisdn} from "../../store/features/Msisdns/msisdnService";
import {selectUserId} from "../../store/features/Auth/authSlice";
import {useFetchMsisdnsAdminQuery} from "../../store/features/MsisdnSettings/msisdnSettingsService";
import {useLocation} from "react-router-dom";
import AdminPanelRestrictedView from "../../components/AdminPanelRestrictedView/AdminPanelRestrictedView";
import {FlagImage} from "react-international-phone";
import {getFormatedPhoneNumber, getFlag} from "../../utilis/msisdnUtilis";
import {IconPicker} from "../../components/IconPicker/IconPicker";

interface GroupDetailsProps {
    admin: boolean;
}

const GroupDetails = ({admin = false}: GroupDetailsProps) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const {id} = useParams<{ id: string }>();
    const isNewGroup = !id;

    const [addGroup] = useAddGroupMutation();
    const [updateGroup] = useUpdateGroupMutation();
    const role = useSelector((state: any) => state.auth.role);
    const location = useLocation();
    const isAdminPath = location.pathname.includes('admin');
    const [icon, setIcon] = useState('');
    const [color, setColor] = useState('');

    const [errors, setErrors] = useState({
        name: '',
        users: '',
    });

    const isMobile = useMediaQuery('(max-width: 960px)');

    const userId = useSelector(selectUserId)

    const { data: groupData, isLoading: groupLoading } = admin ? useFetchAdminGroupByIdQuery({groupId:Number(id), userId}, { skip: isNewGroup })  : useFetchGroupByIdQuery({groupId:Number(id), userId}, { skip: isNewGroup });
    const { data: usersData, isLoading: usersLoading } = useGetUsersQuery();
    const { data: msisdnsData, isLoading: msisdnsLoading } = useFetchMsisdnsAdminQuery({phrase: ''});


    const isLoading = groupLoading || usersLoading || msisdnsLoading;

    const initialFormData = isNewGroup ? {
        name: '',
        description: '',
        type: 'MULTIPLE',
        iconColor: Colors.orange,
        icon: 'star',
        users: [],
        msisdns: []
    } as Group : {
        groupId: groupData?.group?.groupId,
        name: groupData?.group?.name,
        description: groupData?.group?.description,
        type: groupData?.group?.type,
        iconColor: groupData?.group?.iconColor,
        icon: groupData?.group?.icon ?? 'star',
        users: groupData?.users,
        msisdns: groupData?.msisdns
    } as Group;


    const [formData, setFormData] = useState(initialFormData);



    useEffect(() => {
        if (groupData && !isNewGroup) {
            const data: Group = {
                groupId: groupData?.group?.groupId,
                name: groupData?.group?.name ?? '',
                description: groupData?.group?.description,
                type: groupData?.group?.type,
                iconColor: groupData?.group?.iconColor,
                icon: groupData?.group?.icon,
                users: groupData?.users ?? [],
                msisdns: groupData?.msisdns ?? []
            };
            setFormData(data);
            setIcon(groupData?.group?.icon ?? 'star');
            setColor(groupData?.group?.iconColor ?? 'orange');
        }
    }, [groupData, isNewGroup]);

    useEffect(() => {
        
            setIcon(groupData?.group?.icon ?? 'star');
            setColor(groupData?.group?.iconColor ?? 'orange');
        
    }, []);

    const validateGroupName = (value: string) => {
        setErrors(prevState =>
            ({
                ...prevState,
                name: validateName(value) ? '' : 'Group name is required'
            })
        );

    }
    const handleValidation = () => {
        const newErrors = {
            name: validateName(formData.name) ? '' : 'Group name is required',
            users: formData.users?.length ? '' : 'At least one user is required',
        };

        const hasErrors = Object.values(newErrors).some(error => error !== '');
        setErrors(newErrors);
        if(newErrors.users) {
            dispatch(showToast({title:'Cannot create a new group.' , description:'Please add at least one user.', type: 'error' }))
        }
        return !hasErrors;
    };

    const selectedUserIds = formData.users?.map(user => user.userId);
    const selectedMsisdnIds = formData.msisdns?.map(msisdn => msisdn.msisdnId);


    const usersList: selectorItem[] = usersData ? usersData?.data.filter(user => !selectedUserIds?.includes(user.userId)).map((user: UserListItem) => {
        return {
            key: user.userId.toString(),
            label: user.firstName + ' ' + user.lastName,
            value: user.userId.toString(),
            prefixElement: <PhoneHQAvatar src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} size="24px"/>

        }
    }) : [];
    const selectedUsers: selectorItem[] =  formData.users?.map((user: User) => {
        return {
            key: user.userId.toString(),
            label: user.firstName + ' ' + user.lastName,
            value: user.userId.toString(),
            prefixElement: <PhoneHQAvatar src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} size="24px"/>
        }
    });

    const msisdnsList: selectorItem[] = msisdnsData ?  msisdnsData.data.filter(msisdn => !selectedMsisdnIds?.includes(msisdn.msisdnId) && msisdn.assigmentScope != 'PRIVATE' ).map((msisdn: Msisdn) => {
        return {
            key: msisdn.msisdnId.toString(),
            label: msisdn.label,
            value: msisdn.msisdnId.toString(),
            prefixElement: <PhoneHQIconAvatar icon={msisdn.icon} color={msisdn.iconColor} size="24px"/>
        }
    }) : [];

    const selectedMsisdns: selectorItem[] = msisdnsData ?  msisdnsData?.data.filter(msisdn => selectedMsisdnIds?.includes(msisdn.msisdnId)).map((msisdn: Msisdn) => {
        return {
            key: msisdn.msisdnId.toString(),
            label: msisdn.label,
            value: msisdn.msisdnId.toString(),
            prefixElement: <PhoneHQIconAvatar icon={msisdn.icon} color={msisdn.iconColor} size="24px"/>
        }
    }) : [];


    const [users, setUsers] = useState(selectedUsers ?? []);
    const [phoneNumbers, setPhoneNumber] = useState(selectedMsisdns ?? []);

    const handleMenageUsersChange = (res: boolean) => {
        if (!res) {
            setUsers([...selectedUsers]);
            return;
        }

        const matchedUsers = usersData?.data.filter(userData => {
            return users.some(user => Number(user.value) === userData.userId);
        });


        setFormData(prevFormData => {
            return {
                ...prevFormData,
                users: matchedUsers ? matchedUsers.map((user) => ({...user, chatInitializedAt: null})) : [],
            };
        });


        if (matchedUsers && matchedUsers.length > 0 && errors.users) {
            setErrors(prevState => ({
                ...prevState,
                users: '',
            }));
        }
    };

    const handleMenagePhoneNumberChange = (res: boolean) => {
        if (!res) {
            setPhoneNumber([...selectedMsisdns]);
            return;
        }
        if(!msisdnsData) return;
        const matchedNumbers = msisdnsData.data.filter((msisdnsData: Msisdn )=> {
            return phoneNumbers.some(msisdn => Number(msisdn.value) === msisdnsData.msisdnId);
        });
        const data: Group = {
            ...formData,
            msisdns: matchedNumbers,
        };
        setFormData(data);

        if (matchedNumbers.length > 0) {
            setErrors(prevState => ({
                ...prevState,
                msisdns: '',
            }));
        }
    };


    // const handleDataChange = (newData: any) => {
    //     setUsers(newData);
    // };

    const manageUsersTrigger = <PhoneHQButton variant="secondary" disabled={formData.technical} className={!formData.users?.length ? 'w-[215px] mr-6' : 'mr-6 w-[160px]'} phq-id='groupDetails-manageUsersTriggerBtn'>{formData.users?.length ? 'Manage access' : 'Add users'}</PhoneHQButton>

    const managePhoneNumbersTrigger = <PhoneHQButton variant="secondary" disabled={formData.technical} className='w-[250px] mr-6' phq-id='groupDetails-managePhoneNumbersTriggerBtn'>{formData.users?.length ? 'Manage phone numbers' : 'Add phone number'}</PhoneHQButton>

    const addUserModal = <AddUserNumberModal type={'USERS'} users={usersList} data={selectedUsers} setData={setUsers}/>;
    const addPhoneNumberModal = <AddUserNumberModal type={'PHONE_NUMBERS'} data={selectedMsisdns} msisdns={msisdnsList}
                                                    setData={setPhoneNumber}/>;
    
    
    const handleGroupAvatar = (res:boolean) => {
        if(!res) return;
        // const data: Group = {
        //     ...formData,
        //     icon: icon, iconColor: color
        // };
        // setFormData(data);
        setFormData({...formData, icon: icon, iconColor: color});
        console.log(icon, color);

        // setIcon(formData.icon ?? 'star');
        // setColor(formData.iconColor);
    };

    // console.log(icon);
    const manageIconContent = <IconPicker setIcon={setIcon} setColor={setColor} currentIcon={formData.icon} currentColor={formData.iconColor}/>
    const iconModalTrigger = <div className={` ${admin ? 'hover:bg-brand-tint-subtle cursor-pointer ' : ' '} + ' mr-2  rounded p-1.5 mb-1 '`}><div className={` items-center hover:bg-brand-tint-subtle flex  h-[32px] w-[32px] justify-center items-center text-2xl` }>

    <div>
        <PhoneHQIconAvatar icon={formData.icon} color={formData.iconColor} size="32px"/>
    </div></div></div>;

    const handleSubmit = async () => {
        if (!handleValidation()) {

            return;
        }
        if (isNewGroup) {
            await addGroup({newGroup: formData});

        } else {
            await updateGroup(formData);
        }
       navigate('/admin/groups');
    };

    if (isLoading) {
        return (
            <div
                className={`flex w-full  ${isMobile ? ' px-4' : ''}`}>
                <PhoneHQLoader/>
            </div>


        );
    }

    console.log(isNewGroup);
    console.log(groupData?.group.technical)
    return (
        <>
        {Boolean(role == 'USER') &&  isAdminPath &&
            <AdminPanelRestrictedView></AdminPanelRestrictedView>
        }
        <div className='w-full'>
          

            <div >
                <div className={` ${isMobile ? ' px-4' : ''}`}>

                    <div>

                        {!isNewGroup &&
                            <div className=" justify-start items-center gap-3 flex py-5 px-8 border-b border-line">
                                <PhoneHQIconAvatar icon={formData.icon} color={formData.iconColor} size="64px"/>
                                <div className="flex-col justify-start items-center gap-2 flex">
                                    <div
                                        className=" text-center  text-2xl font-semibold  leading-7">{formData?.name}</div>
                                </div>
                            </div>
                        }

                    </div>

                    <div
                        className={` w-full overflow-y-scroll`}>
                        <div className={`flex  border-b  ${isMobile ? ' mt-6' : ' '}` + 'border-line'}>
                            <div className=" border-r border-line px-8 py-5 w-[345px] min-w-[345px]">
                                <div className='font-semibold text-lg '>
                                General information
                                </div>
                                {admin && <div className='text-ink-muted text-sm '>
                                Update name and general information.
                                </div>
                                }
                            </div>
                            <div className='px-6 py-4 w-full'>
                                            <div className={errors.name && ' pb-7'}>
                                            </div> 
                                            <p className="text-sm mb-1">Name</p>

                                            <div className={'flex items-center '}>
                                            {!admin &&
                                            <div>{iconModalTrigger}</div>
                                            }
                                            {admin && !groupData?.group.technical && 
                                            <PhoneHQActionDialog title={'Icon and colour'} trigger={iconModalTrigger} confirmLabel='Apply' cancelLabel='Cancel' onConfirm={() => handleGroupAvatar(true)} onCancel={() => handleGroupAvatar(false)}>{manageIconContent}</PhoneHQActionDialog>
                                            }
                                             <div className="w-full">
                                             <PhoneHQInput phq-id='groupDetails-nameInput' containerClassName='py-3 min-w-full' value={formData?.name}
                                                     error={errors.name}
                                                     placeholder="Enter group name"
                                                     disabled={!admin || groupData?.group.technical}
                                                     onChange={({target: {value: val}}) => {
                                                        validateGroupName(val);
                                                        setFormData(
                                                             {
                                                                 ...formData,
                                                                 name: val,

                                                             })
                                                     }}/>
                                            </div>
                                            </div>
                                        </div>
                         </div>
                         <div className={`flex  border-b  ${isMobile ? ' mt-6' : ' '}` + 'border-line'}>
                            <div className=" border-r border-line px-8 py-5 w-[345px] min-w-[345px]">
                                <div className='font-semibold text-lg '>
                                Users
                                </div>
                                {admin && !groupData?.group.technical && Boolean(formData.users?.length) &&
                                 <div className='text-ink-muted text-sm mb-5'>
                                Assign members to groups for better team organization.
                                </div>
                                }
                                {admin && !groupData?.group.technical && Boolean(formData.users?.length) && <div className=' flex '>
                                    <PhoneHQActionDialog title='Add team member' trigger={manageUsersTrigger} confirmLabel='Confirm' cancelLabel='Cancel' onConfirm={() => handleMenageUsersChange(true)} onCancel={() => handleMenageUsersChange(false)}>{addUserModal}</PhoneHQActionDialog>
                                </div>}
                            </div>
                            <div className="w-full">
                            {admin && Boolean(!formData.users?.length) && <div className='p-6 flex justify-center'>
                                    <PhoneHQActionDialog title='Add team member' trigger={manageUsersTrigger} confirmLabel='Confirm' cancelLabel='Cancel' onConfirm={() => handleMenageUsersChange(true)} onCancel={() => handleMenageUsersChange(false)}>{addUserModal}</PhoneHQActionDialog>
                                </div>}
                            {Boolean(formData?.users?.length > 0) &&
                            <div>
                            <div className={`px-8 py-3 border-y w-full text-xs font-semibold border-line `}>
                                        Users
                                    </div>
                            <table className={`w-full `}>


                                <tbody>

                                    {formData.users?.map((user: User) => (
                                        <tr key={user.userId} className={`border-b border-line w-full` } >

                                            <td className='flex gap-3  items-center pl-4 py-4'>
                                                <PhoneHQAvatar src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} size="40px"/>
                                                {user.firstName + ' ' + user.lastName}
                                            </td>
                                        </tr>))

                                }
                                </tbody>
                                </table>
                                </div>
                                }
                            </div>
                         </div>

                         <div className={`flex  border-b  ${isMobile ? ' mt-6' : ' '}` + 'border-line'}>
                            <div className=" border-r border-line px-8 py-5 w-[345px] min-w-[345px]">
                                <div className='font-semibold text-lg '>
                                Phone numbers
                                </div>
                                {admin && !groupData?.group.technical && Boolean(formData.msisdns?.length) &&
                                 <div className='text-ink-muted text-sm mb-5'>
                                Assign a phone number to this group so it can make and receive calls.
                                </div> }
                                {admin && !groupData?.group.technical && Boolean(formData.msisdns?.length) &&
                                        <div className='flex justify-center'>
                                            <PhoneHQActionDialog title={'Add phone number'} trigger={managePhoneNumbersTrigger} confirmLabel='Confirm' cancelLabel='Cancel' onConfirm={() => handleMenagePhoneNumberChange(true)} onCancel={() => handleMenagePhoneNumberChange(false)}>{addPhoneNumberModal}</PhoneHQActionDialog>
                                        </div>}
                            </div>
                            <div className="w-full">
                            {admin && !groupData?.group.technical && Boolean(!formData.msisdns?.length) &&
                                        <div className='p-6 flex justify-center'>
                                            <PhoneHQActionDialog title={'Add phone number'} trigger={managePhoneNumbersTrigger} confirmLabel='Confirm' cancelLabel='Cancel' onConfirm={() => handleMenagePhoneNumberChange(true)} onCancel={() => handleMenagePhoneNumberChange(false)}>{addPhoneNumberModal}</PhoneHQActionDialog>
                                        </div>}
                            {Boolean(formData.msisdns?.length > 0) &&
                            <>
                            <div className={`px-8 py-3 border-y w-full text-xs font-semibold border-line `}>
                            Phone numbers
                                    </div>
                            <table className={`w-full `}>
                                <tbody>


                                {Boolean(formData.msisdns?.length) &&
                                        formData.msisdns?.map((number) => (
                                            <tr key={number.msisdnId} className={`border-b border-line` }>
                                                <td className='flex gap-3  items-center pl-4 py-4'>
                                                
                                                    <div className='flex gap-3 text-sm items-center'>
                                                    
                                                    <PhoneHQIconAvatar icon={number.icon} color={number.iconColor} size="32px"/>
                                                    
                                                    <div className="flex flex-col">
                                                    {number.label}
                                                    <div className="flex gap-1 items-center">
                                                        <FlagImage size={16} className="w-3 h-3" iso2={getFlag(number.msisdn) ?? 'us'} />
                                                        <div className="text-xs">{getFormatedPhoneNumber(number.msisdn, true)}</div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </td>

                                            </tr>
                                        ))
                                    }
                                </tbody>
                                </table>
                                </>
                                }
                            </div>
                         </div>
                    </div>


                </div>
                {admin && 
                <div className={`${isMobile ? ' px-4' : ''}`}>
                <div className={`m-8 pb-8 flex  ${isNewGroup ? 'justify-end' : ' justify-between'}`}>

                    {
                        
                        !isNewGroup && (groupData?.group.technical ? <div></div> : <DeleteGroupModal/>)


                    }
                    {!groupData?.group.technical &&
                        <div className='flex gap-4 ml-auto'>
                        <Link to={'/admin/groups'}>
                            <PhoneHQButton variant="secondary" size="lg">Cancel</PhoneHQButton>
                        </Link>
                        <PhoneHQButton size="lg" disabled={isLoading} onClick={handleSubmit} phq-id={isNewGroup? 'groupDetails-createNewGroupBtn' : 'groupDetails-editGroupBtn' }>{isNewGroup? 'Create new group' : 'Done' }</PhoneHQButton>
                    </div>
                    }
                </div>
            </div>
                }
                
            </div>
        </div>
        </>
    );
}
export default GroupDetails;
